export default __webpack_public_path__ + "9a7bd6ec36312a2baa7ea12e6bc57df7.svg";